import { useCallback } from 'react';
import type { PartnerDocument } from 'types/Partner';
import useStyles from './PartnerBookmarkItem.styles';

type PartnerBookmarkItemProps = {
  bookmark: PartnerDocument;
};

const PartnerBookmarkItem = ({
  bookmark,
}: PartnerBookmarkItemProps): JSX.Element => {
  const classes = useStyles();

  const handleBookmarkClick = useCallback(
    () => window.open(bookmark.uri),
    [bookmark.uri],
  );

  return (
    <div className={classes.container}>
      <div className={classes.title}>{bookmark.name}</div>

      <div className={classes.bookmark} onClick={handleBookmarkClick}>
        {bookmark.uri}
      </div>
    </div>
  );
};

export default PartnerBookmarkItem;
